import { useCreate, useDelete, useEdit, useGetById } from './useAvailabilityWindow'

export const availabilityWindow = {
  getById: useGetById,
  delete: useDelete,
  create: useCreate,
  edit: useEdit,
}
